import type { PackagingSvhcAuditVerdict } from '@/shared/hooks/api/packagingSuppliers'

export type PackagingItemSvhcAuditStatus =
  | 'not_audited'
  | 'passed'
  | 'failed'
  | 'flagged'

export function svhcAuditVerdictToOverviewStatus(
  verdict: PackagingSvhcAuditVerdict
): PackagingItemSvhcAuditStatus {
  if (verdict === 'SVHC_TEST_REPORT_SVHC_NEGATIVE') {
    return 'passed'
  }
  if (verdict === 'SVHC_TEST_REPORT_SVHC_POSITIVE') {
    return 'failed'
  }
  if (verdict === 'SVHC_STATEMENT') {
    return 'passed'
  }
  if (
    verdict === 'SVHC_TEST_REPORT_INCONCLUSIVE' ||
    verdict === 'SVHC_TEST_REPORT_NOT_PRESENT' ||
    verdict === 'SVHC_STATEMENT_PRESENT_NOT_RELEVANT'
  ) {
    return 'flagged'
  }
  return 'not_audited'
}
